const StatusData = [
  { status: "Support" },
  { status: "No Support" },
  { status: "Unsure" },
  { status: "No Response" },
];
export default StatusData;
